module.exports = __webpack_public_path__ + "static/media/b.a3b0b3e3.svg";